import { useAuth } from '@shared/components/AuthProvider';
import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';

export const DataDogUserSetup = () => {
  const { currentUser } = useAuth();

  useEffect(() => {
    if (!currentUser.profile) {
      return;
    }

    datadogRum.setUser({
      id: currentUser.profile?.id,
      eventId: currentUser.eventMemberships.find(event => event.status === 'owner')?.id
    });
  }, [currentUser]);

  return null;
};
